import { createReducer } from 'Helpers/redux'
import {
  GET_CAMPAIGN_RATES,
  GET_CAMPAIGN_RESULTS,
  GET_CAMPAIGN_REVIEWS,
} from 'Redux/actions/campaignActions'

const initialState = {
  rates: [],
  results: [],
  reviews: [],
}

const handlers = {
  [GET_CAMPAIGN_RATES.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    rates: payload,
  }),
  [GET_CAMPAIGN_RESULTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    results: payload,
  }),
  [GET_CAMPAIGN_REVIEWS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    reviews: payload,
  }),
}

export default createReducer(initialState, handlers)
